import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { galleriesPublicApi } from '../../api/adminApi';
import { galleryId, galleryCoverUrl, publicGalleryPath } from '../Admin/Galleries/galleryHelpers';
import '../AboutPage/AboutPage.css';
import './GalleryPage.css';
import frameOne from '../../assets/images/frameone.svg';

function GalleryPage() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    galleriesPublicApi
      .list(1, 50)
      .then((res) => {
        if (!cancelled) setList(res.list || []);
      })
      .catch(() => {
        if (!cancelled) {
          setList([]);
          setError('Unable to load galleries right now. Please try again later.');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main className="gallery-page">
      <section className="about-banner" aria-label="Life At our preschool">
        <div className="hero-inner">
          <div className="hero-grid">
            <div className="hero-content">
              <h1 className="about-banner-title">Life At Our Preschool</h1>
              <p className="about-banner-desc">
                We maintain the highest standards of safety and care to give you peace of mind.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="gallery-section" aria-labelledby="gallery-heading">
        <div className="gallery-section-inner">
          <h2 id="gallery-heading" className="gallery-section-title">
            Welcome to Preschool Gallery
          </h2>
          {error && (
            <p className="gallery-page-error" role="alert">
              {error}
            </p>
          )}
          {loading ? (
            <p className="gallery-page-loading">Loading galleries…</p>
          ) : list.length === 0 && !error ? (
            <p className="gallery-page-empty">No galleries to show yet. Check back soon.</p>
          ) : (
            <div className="gallery-cards">
              {list.map((item) => {
                const id = galleryId(item);
                if (!id) return null;
                const cover = galleryCoverUrl(item);
                return (
                  <Link key={id} to={publicGalleryPath(id)} className="gallery-card">
                    <div className="gallery-card-image-wrap">
                      <img
                        src={cover || frameOne}
                        alt={item.title ? `${item.title} — cover` : 'Gallery cover'}
                        className="gallery-card-image"
                        loading="lazy"
                      />
                    </div>
                    <footer className="gallery-card-footer">
                      <h3 className="gallery-card-title">{item.title || 'Gallery'}</h3>
                    </footer>
                  </Link>
                );
              })}
            </div>
          )}
          <p className="gallery-back-wrap">
            <Link to="/" className="gallery-back-link">
              ← Back to Home
            </Link>
          </p>
        </div>
      </section>

      <section className="cta" id="schedule-tour">
        <div className="cta-inner">
          <h2 className="cta-title">Ready to Apply?</h2>
          <p className="cta-desc">
            Start your application today or schedule a tour to learn more about our programs.
          </p>
          <div className="cta-actions">
            <Link to={{ pathname: '/admissions', hash: 'schedule-tour' }} className="btn btn-primary cta-primary">
              <span className="btn-icon" aria-hidden="true">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="3"
                    y="4"
                    width="14"
                    height="13"
                    rx="2"
                    stroke="currentColor"
                    strokeWidth="1.6"
                  />
                  <path d="M3 8H17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                  <path d="M8 3V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                  <path d="M12 3V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                  <rect x="7" y="10" width="2.2" height="2.2" rx="0.4" fill="currentColor" />
                </svg>
              </span>
              Schedule
            </Link>
            <a href="#apply" className="btn btn-outline cta-secondary">
              Apply Now
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default GalleryPage;
